"use strict";

exports.__esModule = true;
exports.VASTProperty = void 0;
var _StringUtils = require("../Utils/StringUtils");
function _createForOfIteratorHelperLoose(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (it) return (it = it.call(o)).next.bind(it); if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; return function () { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
/**
 * Represents a VAST property of an element in a VAST document.
 *
 * It is used by several Core objects as a container for the object's name-value pairs.<br/>
 * For a list of possible properties refer to the containing class.
 * 
 * @hideconstructor
 */
var VASTProperty = /*#__PURE__*/function () {
  function VASTProperty(name, value, attributeKey, attributeValue) {
    /** @private */
    this.name = name;
    /** @private */
    this.value = value ? value : "";
    /** @private */
    this.attributes = new Map();
    if (attributeKey && attributeValue) {
      this.addAttribute(attributeKey, attributeValue);
    }
  }
  var _proto = VASTProperty.prototype;
  _proto.addAttribute = function addAttribute(key, value) {
    this.attributes.set(key, value);
  }

  /**
   * @return {string} the name of the VASTProperty
   */;
  _proto.getName = function getName() {
    return this.name;
  }

  /**
   * @return {string} the value of the VASTProperty
   */;
  _proto.getValue = function getValue() {
    return this.value;
  }

  /**
   * @return {Map} a Map of attributes of this VASTProperty as name-value pairs
   */;
  _proto.getAttributes = function getAttributes() {
    return this.attributes;
  };
  _proto.setValue = function setValue(value) {
    this.value = value;
  };
  _proto.toString = function toString() {
    var s = "";
    s += "Property Name: ";
    s += this.name;
    if (!(0, _StringUtils.isNullOrEmpty)(this.value)) {
      s += ", Value: ";
      s += this.value;
    }
    if (this.attributes.size > 0) {
      s += ", Attributes:{";
      for (var _iterator = _createForOfIteratorHelperLoose(this.attributes), _step; !(_step = _iterator()).done;) {
        var _step$value = _step.value,
          key = _step$value[0],
          value = _step$value[1];
        s += key + ":" + value + " ";
      }
      s += "}";
    }
    return s;
  };
  return VASTProperty;
}();
exports.VASTProperty = VASTProperty;